import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

/**
 * 🔐 RoleRoute — Protects routes based on Keycloak roles.
 *
 *  Supports flattened realm & client roles (see extractRoles()).
 *  Handles loading, unauthenticated state, and unauthorized fallback.
 *  Admin bypass (full access).
 */
const RoleRoute = ({
  allowedRoles = [],
  fallback = "/expo",
  children
}) => {
  const {
    auth,
    hasRole
  } = useAuth();

  // Wait for Keycloak initialization
  if (auth.loading) return <div>Loading…</div>;

  // Not logged in → send to login
  if (!auth.isAuthenticated) return <Navigate to="/login" replace />;

  // Admin and superadmin override (full access)
  const isSuperuser = hasRole("superadmin") || hasRole("admin");

  // Check allowed roles
  const isAllowed = isSuperuser || allowedRoles.some(role => hasRole(role));

  // 🔎 Optional debug logs (only during development)
  if (process.env.NODE_ENV === "development") {}

  // Authorized → render page
  if (isAllowed) return children;

  // Unauthorized → redirect to fallback (safe page)
  return <Navigate to={fallback} replace />;
};
export default RoleRoute;